module.exports = __webpack_public_path__ + "img/anison_pianist_takechan.318be9c8.png";